export default "__VITE_ASSET__C$5KzK1w__"